<template>
  <div v-loading="loadingTenant">
    <div v-if="!tenantId">
      <h2>{{ $t("login.login-as-company")  }}</h2>
      <el-form :model="form" size="medium" ref="formRef" @submit.native.prevent="searchTenant">
        <el-form-item :label="$t('login.company-name')">
          <el-input v-model="form.tenantName" :disabled="searchingTenant"></el-input>
        </el-form-item>
        <el-checkbox v-model="form.rememberCompany">{{ $t("login.remember-company")  }}</el-checkbox>
      </el-form>
      <el-button type="primary" class="button" :loading="searchingTenant" :disabled="!form.tenantName" @click="searchTenant">{{ $t("login.search-company") }}</el-button>
      <p v-show="errorMessage" class="text-center error-message">{{ errorMessage }}</p>
    </div>
    <div v-else>
      <h2 class="text-center">{{ $t("login.login-as", { name: form.tenantName }) }}</h2>
      <el-avatar :size="200" :src="tenant.logo" class="logo"></el-avatar>
      <div class="buttons">
        <el-button class="google" v-if="tenant.google" @click="signInWithGoogle" :loading="googleSignIn">
          <i class="fab fa-google"></i>
          {{ $t("login.sign-with-google") }}
        </el-button>
        <el-button class="google" v-if="tenant.saml" @click="signInWithSaml" :loading="samlSignIn">
          {{ $t("login.sign-with-sso") }}
        </el-button>
      </div>
    </div>
    <div class="buttons">
      <router-link :to="{ name : 'Login' }" class="text-center">{{ $t("login.go-back-to-login")  }}</router-link>
      <router-link :to="{ name : 'ManageCompany' }" class="text-center" v-if="tenantsSaved.length > 0">{{ $t("login.manage-company")  }}</router-link>
    </div>
  </div>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/auth';
import http from "@/api/http"
export default {
  props: {
    name: {
      required: false,
      default: '',
    }
  },
  data() {
    return {
      form: {
        tenantName: "",
        rememberCompany: false,
      },
      searchingTenant: false,
      errorMessage: "",
      providers: [],
      tenant: null,
      tenantId: "",
      tenantKey: "tenant",
      tenantsSaved: [],
      googleSignIn: false,
      samlSignIn: false,
      loadingTenant: false
    }
  },
  methods: {
    async searchTenant(evt) {
      if (evt) {
        evt.preventDefault()
      }

      this.searchingTenant = true;
      try {
        const { data } = await http.get(`/tenants/fetch-by-name/${this.form.tenantName}`);
        this.tenant = data;
        this.tenantId = this.tenant.tenantId

        if (this.form.rememberCompany) {
          this.tenantsSaved = [this.tenant];
          localStorage.setItem(this.tenantKey, JSON.stringify(this.tenantsSaved));
        }

        if (this.tenant.tenantId) {
          firebase.auth().tenantId = this.tenantId;
        }
      } catch (err) {
        if (err.response.status === 404) {
          this.errorMessage = "No se encontro esa empresa"
        }
      } finally {
        this.searchingTenant = false;
      }
    },
    async signInWithGoogle() {
      this.googleSignIn = true;
      const provider = new firebase.auth.GoogleAuthProvider();
      this.signInWithProvider(provider).finally(() => {
        this.googleSignIn = false;
      })
    },
    async signInWithSaml() {
      this.samlSignIn = true
      const provider = new firebase.auth.SAMLAuthProvider(this.tenant.smalProviderId);
      this.signInWithProvider(provider).finally(() => {
        this.samlSignIn = false
      })
    },
    async signInWithProvider(provider) {
      const { user } = await firebase.auth().signInWithPopup(provider);
      const idToken = await user.getIdToken();
      this.$store.dispatch('verifyToken', idToken).then(() => {
        this.$store.commit("SET_USER_EMAIL", user.email);
        window.location.href = "/home"
      })
    }
  },
  async beforeMount() {
    if (this.name) {
      this.loadingTenant = true
      try {
        const { data } = await http.get(`/tenants/fetch-by-name/${this.name}`)
        this.tenant = data;
        this.tenantId = data.tenantId;
        this.form.tenantName = data.name;
          
        if (data.tenantId) {
          firebase.auth().tenantId = data.tenantId;
        }
        return;
      } catch (error) {
        this.$router.push({ name: 'LoginAsTenant'});
        return;
      } finally {
        this.loadingTenant = false
      }
    }

    const tenantsTmp = JSON.parse(localStorage.getItem(this.tenantKey));
    this.tenantsSaved = tenantsTmp ?? []
    if (this.tenantsSaved && this.tenantsSaved.length > 0) {
      const tenant = this.tenantsSaved[0]
      this.rememberCompany = true;
      this.form.tenantName = tenant.name;
      await this.searchTenant();
    }
  },
}
</script>

<style scoped>
.button {
  width: 100%;
  margin-top: var(--column);
}

.text-center {
  margin-top: var(--column);
  text-align: center;
}

.error-message {
  color: var(--red);
}

.google {
  background-color: #4285F4;
  border: 1px solid #4285F4;
  color: #fff;
  font-family: 'Roboto', sans-serif;
}

.buttons {
  display: grid;
  gap: var(--column);
  margin-bottom: var(--column);
}

.logo {
  display: block;
  margin: calc(var(--column) * 2) auto;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}

.el-button+.el-button {
  margin-left: 0!important;
}

.buttons a {
  text-align: center;
}

</style>